export const BUSINESS_PARTNER_SIDEBAR_NAMESPACE = 'business-partner-sidebar';
